import { GetterTree } from 'vuex'
import * as types from './types'

export default <GetterTree<file.state.FileState, RootState>>{
	[types.FILE_LIST](state) {
		return state.files
	},
}
